module.exports = require('./helpers/bundle-url').getBundleURL('8v5FU') + "logo-dark.ba5147f0.svg";